const pmeta = {
  "pmeta.min": "min.",
  "pmeta.anes_local": "Local anesthesia",
  "pmeta.anes_general": "General anesthesia",
  "pmeta.anes_none": "None",
  "pmeta.sessions_1": "1 appointment",
  "pmeta.sessions_2": "2 appointments",
  "pmeta.sessions_1_2": "1–2 appointments",
  "pmeta.sessions_2_3": "2–3 appointments",
  "pmeta.sessions_ongoing": "Ongoing",
};

export default pmeta;
